export default __webpack_public_path__ + "static/media/google_cap_pic.b316a9f0.jpeg";